//
//
//
//
//
//
//
//
//
//

import BrowserMixin from "@Shared/utils/application-mixins/browser-mixin";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SimpleLayout",
  mixins: [BrowserMixin]
});